import { useCallback, useState } from 'react';

import { CreateQuizEventAdapter } from '~analytics/adapters/CreateQuizEventAdapter';
import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions';
import { handleImportQuizError } from '~teacher/hook/useImportQuizToPersonalBySocMutation';
import { useImportQuizToWorkspaceBySocMutation } from '~teacher/hook/workspaces';

interface UseImportQuizBySocToWorkspaceParams {
  workspaceId: string;
  parentFolderId: string;
  onClose: () => void;
}

export function useImportQuizBySocToWorkspace({
  workspaceId,
  parentFolderId,
  onClose,
}: UseImportQuizBySocToWorkspaceParams) {
  const [isImportDisabled, setIsImportDisabled] = useState(false);

  const importQuizToWorkspaceBySocMutation =
    useImportQuizToWorkspaceBySocMutation();

  const importBySocNumber = useCallback(
    (socNumber: string) => {
      setIsImportDisabled(true);

      importQuizToWorkspaceBySocMutation.mutate(
        { workspaceId, socNumber, parentFolderId },
        {
          onSettled: () => setIsImportDisabled(false),
          onSuccess: (resp) => {
            apiToaster([], QuizToastActions.IMPORT);
            new CreateQuizEventAdapter({
              creation_method: 'code',
              source_soc_number: resp['originalSocNumber'],
            }).sendAnalytics();
            onClose();
          },
          onError: handleImportQuizError(() => {
            /* There is no limit on workspace quizzes ATM, so this will never be hit. */
          }),
        }
      );
    },
    [importQuizToWorkspaceBySocMutation, onClose, parentFolderId, workspaceId]
  );

  return {
    ...importQuizToWorkspaceBySocMutation,
    importBySocNumber: importBySocNumber,
    isImportDisabled: isImportDisabled,
  };
}
